import EdiUser from './user/EdiUser';
import EdiComments from './comments/EdiComments';
import EdiValuation from './valuation/EdiValuation';
import EdiPoll from './poll/EdiPoll';
import EdiSearcher from './searcher/EdiSearcher';
import EdiReport from './report/EdiReport';
import EdiUserMenuMobile from './user/EdiUserMenuMobile';
import EdiSocialButtons from './socialbuttons/EdiSocialButtons';
import EdiFooterInfo from './footer/EdiFooterInfo';

import Vue from 'vue';

/**
 * IMPORTANTE:
 *
 * Este proyecto consta de dos partes de Javascript: la parte de interactividad de la web
 * en general, cuyos ficheros viven en resources/views/**\/*.js y la aplicación de Vue
 * encargada de funcionalidades "interactivas".
 * La idea de usar Vue viene motivada por la necesidad de tener un punto centralizado
 * donde realizar todas las operaciones de la web, idealmente los scripts puramente de js
 * se irán llevando a la aplicación de Vue.
 *
 * La idea para inicializar la aplicación de Vue es inicializar la aplicación a nivel general,
 * en el body (o un elemento inmediatamente interior) y usar los componentes de cada
 * funcionalidad recibiendo en las propiedades los datos directamente desde la plantilla de twig.
 * De esta manera todos los componentes estarán conectados mediante la misma instancia de Vue permitiendo
 * reactividad en toda la web frente a eventos como loging, comentarios, likes, etc etc
 * Sin embargo esto no es posible técnicamente dado que hay etiquetas <script> y <style> dentro
 * del body de la página. Por ello Vue no puede inicializar la app y hemos optado por inicializar
 * distintas aplicaciones para cada funcionalidad y éstas comparten la store de Vuex.
 *
 * Este mapa se encarga precisamente de eso, indica en la clave el selector del elemento del DOM
 * donde se inicializara la aplicación de esa funcionalidad y como valor de esa clave el componente
 * que constituye la funcionalidad.
 *
 */
const Apps = {
  '#edi-comments': EdiComments,
  '.edi-user-menu': EdiUser,
  '.edi-user-menu-mobile': EdiUserMenuMobile,
  '.valuation-btn': EdiValuation,
  '.edi-poll': EdiPoll,
  '.edi-searcher': EdiSearcher,
  '.edi-report': EdiReport,
  '.edi-social-buttons': EdiSocialButtons,
  '.footer-info': EdiFooterInfo,
};

export default (store) => {
  Object.entries(Apps).forEach(([selector, component]) => {
    const htmlElement = document.querySelectorAll(selector);
    htmlElement.forEach(el => {
      new Vue({
        el,
        store,
        components: { [component.name] : component },
      });
    });
  });
}
